import styled, { css } from 'styled-components/macro'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { respondBelow, respondAbove } from 'styles/mediaQueries'
import ticketDecor from 'assets/images/decors/ticketDecor.svg'
import { shouldForwardProp } from 'helpers'

export const Wrapper = styled(Box)<{ areDetailsVisible: boolean }>`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px;
    border-top: 8px solid ${({ theme }) => theme.colors.primary_500};

    ${({ areDetailsVisible }) =>
        areDetailsVisible &&
        css`
            ${Ticket} {
                box-shadow: 0 4px 35px rgba(32, 0, 139, 0.05);
            }
        `}

    @media ${respondAbove.xl} {
        border-top: 0;
        border-radius: 8px 0 0 8px;
        border-left: 8px solid ${({ theme }) => theme.colors.primary_500};

        ${({ areDetailsVisible }) =>
            areDetailsVisible &&
            css`
                border-radius: 8px 0 8px 8px;
            `}
    }
`

export const Ticket = styled(Box)`
    @media ${respondAbove.xl} {
        position: relative;

        &::after {
            content: '';
            background-image: url(${ticketDecor});
            height: 100%;
            width: 20px;
            position: absolute;
            display: block;
            right: -20px;
            top: 0;
            background-position: right;
        }
    }
`

export const DateLabel = styled(Box)`
    background-color: ${({ theme }) => theme.colors.secondary_100};
    border-radius: 8px;
`

interface PriceWrapperProps {
    isAbsoluteOnMobile?: boolean
}

export const PriceWrapper = styled(Text).withConfig({
    shouldForwardProp: (prop) =>
        shouldForwardProp<PriceWrapperProps>(['isAbsoluteOnMobile'], prop),
})<PriceWrapperProps>`
    ${({ isAbsoluteOnMobile }) =>
        isAbsoluteOnMobile &&
        css`
            @media ${respondBelow.xl} {
                position: absolute;
                right: 0;
                top: 0;
            }
        `}

    @media ${respondAbove.xl} {
        min-width: 64px;
    }
`
